/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1SsoimageIdVideoMutationRequest,
  PostApiV1SsoimageIdVideoMutationResponse,
  PostApiV1SsoimageIdVideoPathParams,
  PostApiV1SsoimageIdVideo400,
  PostApiV1SsoimageIdVideo401,
  PostApiV1SsoimageIdVideo404,
  PostApiV1SsoimageIdVideo500,
} from "../../types/SSOImageController/PostApiV1SsoimageIdVideo.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1SsoimageIdVideoUrl(
  id: PostApiV1SsoimageIdVideoPathParams["id"],
) {
  const res = { method: "POST", url: `/api/v1/ssoimage/${id}/video` as const };
  return res;
}

/**
 * @description Realiza o upload de um arquivo de vídeo para o Azure Blob Storage vinculado à SSOImage. O tamanho máximo é configurável via SSOImage:VideoMaxSizeMb em appsettings.json. **(Requer Authorization para autenticação)**
 * @summary Upload de vídeo SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id/video}
 */
export async function postApiV1SsoimageIdVideo(
  id: PostApiV1SsoimageIdVideoPathParams["id"],
  data: PostApiV1SsoimageIdVideoMutationRequest,
  config: Partial<RequestConfig<PostApiV1SsoimageIdVideoMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SsoimageIdVideo400
      | PostApiV1SsoimageIdVideo401
      | PostApiV1SsoimageIdVideo404
      | PostApiV1SsoimageIdVideo500
    >,
    PostApiV1SsoimageIdVideoMutationRequest
  >({
    method: "POST",
    url: getPostApiV1SsoimageIdVideoUrl(id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
